<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>



    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmadminredir',
  components: {
      GrcDB,
      GrcDialog,
  },
  props: {

  },
  data () {
      return {


      }
  },
  model: {
  },  
  methods:{


  },
  created()
  {

  },
  mounted()
  {
    gDashboardUgyfelID = 0;
    if (GRCAPP_GetParameters.hasOwnProperty("APDASHBOARDID"))
    {
        gDashboardUgyfelID = GRCAPP_GetParameters.APDASHBOARDID;
    }
    
    document.location = "dashboard";

  }

}


</script>


<style scoped>



</style>